var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "div",
                      _vm._g(
                        { attrs: { slot: "activator" }, slot: "activator" },
                        on
                      ),
                      [
                        _vm._t("default", [
                          _c(
                            "v-btn",
                            { attrs: { icon: "" } },
                            [_c("v-icon", [_vm._v("edit")])],
                            1
                          )
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("deputyAuth.form.title")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.computedAvailableUsers,
                          label:
                            _vm.$t(
                              "deputyAuth.form.fields.permittedUser.name"
                            ) + "*",
                          rules: _vm.validators.user_id
                        },
                        model: {
                          value: _vm.contextDeputyAuth.user_id,
                          callback: function($$v) {
                            _vm.$set(_vm.contextDeputyAuth, "user_id", $$v)
                          },
                          expression: "contextDeputyAuth.user_id"
                        }
                      }),
                      _c("date-time-picker-computed", {
                        attrs: {
                          "date-time-model": _vm.contextDeputyAuth.from_date,
                          label: _vm.$t(
                            "userSubstitute.userReplacementForm.fields.fromTime.name"
                          ),
                          placeholder: _vm.$t(
                            "userSubstitute.userReplacementForm.fields.fromTime.placeholder"
                          )
                        },
                        on: {
                          "update:dateTimeModel": function($event) {
                            return _vm.$set(
                              _vm.contextDeputyAuth,
                              "from_date",
                              $event
                            )
                          },
                          "update:date-time-model": function($event) {
                            return _vm.$set(
                              _vm.contextDeputyAuth,
                              "from_date",
                              $event
                            )
                          }
                        }
                      }),
                      _c("date-time-picker-computed", {
                        attrs: {
                          "date-time-model": _vm.contextDeputyAuth.to_date,
                          label: _vm.$t(
                            "userSubstitute.userReplacementForm.fields.toTime.name"
                          ),
                          placeholder: _vm.$t(
                            "userSubstitute.userReplacementForm.fields.toTime.placeholder"
                          )
                        },
                        on: {
                          "update:dateTimeModel": function($event) {
                            return _vm.$set(
                              _vm.contextDeputyAuth,
                              "to_date",
                              $event
                            )
                          },
                          "update:date-time-model": function($event) {
                            return _vm.$set(
                              _vm.contextDeputyAuth,
                              "to_date",
                              $event
                            )
                          }
                        }
                      }),
                      _c("v-text-field", {
                        attrs: { label: _vm.$t("global.comment") },
                        model: {
                          value: _vm.contextDeputyAuth.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.contextDeputyAuth, "comment", $$v)
                          },
                          expression: "contextDeputyAuth.comment"
                        }
                      }),
                      _c("v-autocomplete", {
                        attrs: {
                          label:
                            _vm.$t("deputyAuth.form.fields.authItem.name") +
                            "*",
                          items: _vm.computedAvailableItems,
                          rules: _vm.validators.item_name
                        },
                        model: {
                          value: _vm.contextDeputyAuth.item_name,
                          callback: function($$v) {
                            _vm.$set(_vm.contextDeputyAuth, "item_name", $$v)
                          },
                          expression: "contextDeputyAuth.item_name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }